import { Component, OnInit } from '@angular/core'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
} from '../../../core/models/contact-type.model'
import { PriceQuoteStatusCreateComponent } from '../../../features/price-quote/price-quote-status-create/price-quote-status-create.component'
import { MatButton } from '@angular/material/button'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { TableListTariffComponent } from '../../../shared/components/table-list-tariff/table-list-tariff.component'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import { PurchasesQuoteSupplierService } from '../../../core/services/purchases/purchases-quote-supplier/purchases-quote-supplier.service'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import {
  ReactiveFormsModule,
} from '@angular/forms'
import { FormSearchProposalClientComponent } from '../../../shared/components/form-search-proposal-client/form-search-proposal-client.component'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { TableListProposalPageComponent } from '../../../shared/components/table-list-proposal-page/table-list-proposal-page.component'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { TableListPurchasesQuoteSupplierPageComponent } from '../../../shared/components/table-list-purchases-quote-supplier-page/table-list-purchases-quote-supplier-page.component'
import { PurchasesQuoteSupplierTgViewComponent } from '../../../features/purchases/purchases-quote-supplier/purchases-quote-supplier-tg-view/purchases-quote-supplier-tg-view.component'
import { FormSearchQuoteTgComponent } from '../../../shared/components/form-search-quote-tg/form-search-quote-tg.component'
import { MatTabsModule } from '@angular/material/tabs'
import { PurchasesDiscountTgViewComponent } from '../../../features/purchases/purchases-quote-supplier/purchases-discount-tg-view/purchases-discount-tg-view.component'
import { MatTooltipModule } from '@angular/material/tooltip'

@Component({
  selector: 'purchases-quote',
  imports: [
    FormSearchComponent,
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    PriceQuoteStatusCreateComponent,
    MatButton,
    FormClientSearchComponent,
    TableListTariffComponent,
    MatPaginatorModule,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    FormSearchProposalClientComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    TableListProposalPageComponent,
    TableListPurchasesQuoteSupplierPageComponent,
    FormSearchQuoteTgComponent,
    MatTabsModule,
    MatTooltipModule,
  ],
  templateUrl: './purchases-quote.component.html',
  styleUrl: './purchases-quote.component.scss',
  providers: [ProposalClientService, AuthService],
  standalone: true,
})
export class PurchasesQuoteComponent implements OnInit {
  constructor(
    private purchasesQuoteSupplierService: PurchasesQuoteSupplierService,
    private snackbar: SnackbarCustomService,

    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  // searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  searchForm: any = { search: false, model: {} }
  inputSearch = ''

  /*
    propostaId	31
    tg	"TG25-0001"
    clienteId	13
    tipoPessoaId	2
    pessoaId	24
    nome	"Betina e Paulo Mudanças Ltda"
    cnpjCpf	"06840590000147"
    nomeEvento	"Evento Teste"
    dataEventoInicio	"17/08/2025"
    dataEventoFim	"17/08/2025"
    subClienteId	null
    subClienteTipoPessoaId	null
    subClientePessoaId	null
    subClienteNome	null
    subClienteCnpjCpf	null
    consultorId	136
    consultorNome	"Rita Rebeca Ferreira"
    consultorEmail	"rita_ferreira@danielvasconcelos.com.br"
    consultorComercialId	1
    consultorComercialPessoaId	10
    consultorComercialNome	"Gael Real"
    solicitante	"Rita Rebeca Ferreira"
    solicitanteEmail	"rita_ferreira@danielvasconcelos.com.br"
  */

  columns: any[] = [
    {
      keyColumn: 'tg_info',
      key: 'tg_info',
      description: 'Proposta',
    },
    {
      keyColumn: 'client_info',
      key: 'client_info',
      description: 'Cliente',
    },
    {
      keyColumn: 'consultant_info',
      key: 'consultant_info',
      description: 'Consultor',
    },
    {
      keyColumn: 'event_period',
      key: 'event_period',
      description: 'Período',
    },
    {
      keyColumn: 'action',
      key: {
        view: true,
      },
      description: 'Ações',
    },
  ]

  spinLoad: any = {
    contract: false,
    email: false,
    download: false,
    edit: false,
    manager: false,
    view: false,
    remove: false,
  }

  // screen: string = 'status cotação'
  screen = 'compras'

  // Aba "Solicitação de Desconto" (agrupada por proposta, igual à Cotação Fornecedor)
  discountList: any[] = []
  discountGroupedAll: any[] = []
  discountPage = 1
  discountRows = 10
  discountNumberRows = 0
  discountPendingCount = 0
  discountLoading = false
  discountLoaded = false
  discountColumns: any[] = [
    { keyColumn: 'tg_info', key: 'tg_info', description: 'Proposta' },
    { keyColumn: 'client_info', key: 'client_info', description: 'Cliente' },
    {
      keyColumn: 'consultant_info',
      key: 'consultant_info',
      description: 'Consultor',
    },
    { keyColumn: 'event_period', key: 'event_period', description: 'Período' },
    { keyColumn: 'action', key: { view: true }, description: 'Ações' },
  ]

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
    this.getDiscountList()
  }

  onTabChange(index: number) {
    if (index === 1 && !this.discountLoaded) {
      this.getDiscountList()
    }
  }

  getDiscountList() {
    this.discountLoading = true
    // Carrega todas as solicitações pendentes e agrupa por proposta no cliente;
    // a paginação da aba passa a ser sobre as propostas agrupadas.
    this.purchasesQuoteSupplierService
      .listPagedDiscountRequests(1, 999)
      .subscribe({
        next: (response: any) => {
          const data = response?.data ?? []
          this.discountPendingCount = response?.totalItens ?? data.length
          this.discountGroupedAll = this.groupDiscountByProposal(data)
          this.discountNumberRows = this.discountGroupedAll.length
          this.discountPage = 1
          this.sliceDiscount()
          this.discountLoaded = true
        },
        error: () => {
          this.discountList = []
          this.discountGroupedAll = []
          this.discountNumberRows = 0
          this.discountPendingCount = 0
        },
        complete: () => {
          this.discountLoading = false
        },
      })
  }

  groupDiscountByProposal(data: any[]): any[] {
    const groups = new Map<any, any>()
    for (const row of data) {
      const key = row.propostaId ?? row.tg
      if (!groups.has(key)) {
        groups.set(key, { ...row, items: [] })
      }
      groups.get(key).items.push(row)
    }
    return Array.from(groups.values()).map((group) => ({
      ...group,
      qtdDescontos: group.items.length,
    }))
  }

  sliceDiscount() {
    const start = (this.discountPage - 1) * this.discountRows
    this.discountList = this.discountGroupedAll.slice(
      start,
      start + this.discountRows,
    )
  }

  onDiscountPageEvent(event: PageEvent) {
    this.discountPage = event.pageIndex + 1
    this.discountRows = event.pageSize
    this.sliceDiscount()
  }

  viewDiscountItem(group: any) {
    const dialogRef = this.dialog.open(PurchasesDiscountTgViewComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: group,
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.getDiscountList()
      }
    })
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        // edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
        download: true,
        view: true,
        sendContract: true,
        sendEmail: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    this.page = 1
    this.searchForm = event
    if (event.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.purchasesQuoteSupplierService
      .listPagedPurchasesQuoteSupplierByTG(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.purchasesQuoteSupplierService
      .searchPagedPurchasesQuoteSupplierByTG(
        this.page,
        this.rows,
        this.searchForm.model,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  viewItem(item: any) {
    const dialogRef = this.dialog.open(PurchasesQuoteSupplierTgViewComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: item,
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
  }
}
